import app from 'flarum/forum/app';
import { extend, override } from 'flarum/common/extend';

import DiscussionComposer from 'flarum/forum/components/DiscussionComposer';
import ReplyComposer from 'flarum/forum/components/ReplyComposer';

import AnonymousWarningModal from './components/AnonymousWarningModal';


function addAnonymousBanner(Component) {
    extend(Component.prototype, 'headerItems', function (items) {

        // Rien pour les utilisateurs connectés
        if (app.session.user) {
            return;
        }

        items.add(
            'anonymousWarning',
            <div className="AnonymousWarningBanner">
                <strong>
                    {app.translator.trans(
                        'roglo-anonymous-warning.forum.banner.title'
                    )}
                </strong>

                <span>
                    {app.translator.trans(
                        'roglo-anonymous-warning.forum.banner.text'
                    )}
                </span>
            </div>,
            -100
        );
    });
}


function protectAnonymousSubmit(Component) {
    override(Component.prototype, 'onsubmit', function (original, ...args) {

        // Utilisateur identifié : publication normale
        if (app.session.user) {
            return original(...args);
        }

        // Empêche l'envoi immédiat
        app.modal.show(AnonymousWarningModal, {
            onConfirm: () => {
                original(...args);
            }
        });

        return false;
    });
}


app.initializers.add('roglo-anonymous-warning', () => {
    addAnonymousBanner(DiscussionComposer);
    addAnonymousBanner(ReplyComposer);

    protectAnonymousSubmit(DiscussionComposer);
    protectAnonymousSubmit(ReplyComposer);
});
